/**
 * Link states of an organization's GMF provider-account row, owned by
 * `fleet-partners-api`. `ACTIVE` is the only value that means GMF linked.
 *
 * An organization with no row at all is a distinct state from `DISABLED` and is
 * represented as `undefined` rather than a member of this union. The backing
 * enum also carries `PENDING_UNLINK` and `ERROR_*`, which the GMF link flow
 * never produces.
 */
export const GmfProviderAccountStatus = {
  /** GMF validated the organization; the customer has not signed terms yet. */
  PENDING_LINK: 'PENDING_LINK',
  /** Linked. */
  ACTIVE: 'ACTIVE',
  /** Unlinked by an advisor, which frees the Tax ID for reuse. */
  DISABLED: 'DISABLED',
} as const;

export type GmfProviderAccountStatus =
  (typeof GmfProviderAccountStatus)[keyof typeof GmfProviderAccountStatus];
